import React, { Component } from 'react';
import { connect } from "react-redux";
import * as XLSX from 'xlsx';

import { Row, Column } from "@sm/helpers/simple-flexbox";
import { Panel } from "react-bootstrap";

import CustomButton from "@sm/components/custom/Button";
import PageHeader from "@sm/components/PageHeader";
import Form from "@sm/core/Form";
import Select from "@sm/components/custom/Select";
import Spinner from '@sm/components/Spinner';

import '@assets/css/payouts.css';
import Arrow from '@assets/images/arrow.png';
import PayoutIcon from '@assets/images/payouts.png';

import * as actions from "@sm/actions";
import { crudActions } from "@sm/services/crudActions";

class ManualPayout extends Component {
  constructor(props) {
    super(props);
    this.state = Object.assign({
      companies: [],
      companiesClients: {},
      companiesProviders: {},
      companiesClientsPayoutMids: {},
      loadingXlsx: false,
    }, this.getInitialState());
  }

  getInitialState = () => {
    return {
      filterForm: new Form({
        companyId: "",
        merchantId: "",
        providerId: "",
        payoutMidId: ""
      }, [{
        name: "companyId",
        type: "isString",
        rules: {
          required: true
        }
      }, {
        name: "merchantId",
        type: "isString",
        rules: {
          required: true
        }
      }, {
        name: "providerId",
        type: "isString",
        rules: {
          required: true
        }
      }, {
        name: "payoutMidId",
        type: "isString",
        rules: {
          required: true
        }
      }]),

      parsedData: {},
      fields: [],
      additionalFields: [],
      fieldHeaders: {},

      fileUploaded: "",

      showSecondStep: false,
      showThirdStep: false,

      submitClicked: false,
      uploadClicked: false,
      finishImportClicked: false
    };
  };

  componentDidMount() {
    crudActions.get(`v1/companies/clients`).then(
      (companiesData) => {
        if (companiesData) {
          const companies = companiesData.map(elem => elem.company);
          companies.sort((elemA, elemB) => elemA.label.localeCompare(elemB.label));

          this.setState({
            companies: companies,
            companiesClients: companiesData.reduce((accumulator, currentElem) => {
              accumulator[currentElem.company.value] = currentElem.clients.map(elem => elem.client);
              return accumulator;
            }, {}),
            companiesProviders: companiesData.reduce(
              (accumulator, currentElem) => {
                accumulator[currentElem.company.value] = currentElem.psps.map(elem => elem);
                return accumulator;
              }, {}),
            companiesClientsPayoutMids: companiesData.reduce((accumulator, currentElem) => {
              accumulator[currentElem.company.value] = currentElem.clients.reduce((accum, curElem) => {
                accum[curElem.client.value] = curElem.payoutMids;
                return accum;
              }, {});
              return accumulator;
            }, {}),
          }, () => {
            companies.length && this.onFilterValueChange(companies[0], "companyId");
          });
        }
      }
    );
  };

  filterMids = () => {
    const { filterForm, companiesClientsPayoutMids } = this.state;
    if (!filterForm.companyId || !filterForm.merchantId || !filterForm.providerId) {
      return [];
    }

    const companiesMids = companiesClientsPayoutMids[filterForm.companyId];

    return companiesMids[filterForm.merchantId].filter((mid) => filterForm.providerId === mid.pspId.toString());
  };

  getMidNameById = (midId) => {
    const { filterForm, companiesClientsPayoutMids } = this.state;
    if (!filterForm.companyId || !filterForm.merchantId || !filterForm.providerId) {
      return [];
    }

    const companiesMids = companiesClientsPayoutMids[filterForm.companyId];

    return companiesMids[filterForm.merchantId].find((mid) => mid.value.toString() === midId.toString()).label;
  };

  onFilterValueChange = (event, fieldName) => {
    let { filterForm } = this.state;
    const { submitClicked } = this.state;
    const fieldType = filterForm.fieldRules.find(elem => elem.name === fieldName).type;
    filterForm = Object.assign(filterForm, {
      [fieldName]: fieldType === "isNumber" ? parseFloat(event.value) : event.value
    });

    if (submitClicked) {
      filterForm.isFormValid();
    }

    this.setState({
      filterForm
    });
  };

  onSubmit = () => {
    const { filterForm } = this.state;
    const isFilterFormValid = filterForm.isFormValid();

    this.setState({
      filterForm: filterForm,
      submitClicked: true
    });

    if (isFilterFormValid) {
      const payoutS2S = "/api/v5/external/payout/s2s";
      Promise.all([
        crudActions.get(`v1/generate-order/inputs?client=${filterForm.merchantId}&url=${payoutS2S}`),
        crudActions.get(`v1/generate-order/inputs/additional?client=${filterForm.merchantId}&url=${payoutS2S}&midId=${filterForm.payoutMidId}`)
      ])
        .then((data) => {
          let inputs = data[0];
          const additionalInputs = data[1];

          if (inputs) {
            if (additionalInputs.fields.length) {
              inputs = inputs.concat(additionalInputs.fields);
            }
            this.setState({
              fields: inputs,
              additionalFields: additionalInputs.fields,
              fieldHeaders: new Form(inputs.reduce((accumulator, currElem) => {
                accumulator[currElem.fieldName] = "";
                return accumulator;
              }, {}), inputs.map(elem => {
                return {
                  name: elem.fieldName,
                  type: "isString",
                  rules: {
                    required: elem.required
                  }
                };
              }))
            });
          }
        })
        .catch((err) => {
          if (err && err.message) {
            this.props.showAlert(true, "error", err.message);
          }
        });
      this.setState({
        showSecondStep: true
      });
    }
  };

  formParsedResultData = (parsedData) => {
    try {
      const headers = parsedData[0];
      const formedData = [];
      const parsedDataLength = parsedData.length;
      const formObject = (array) => {
        const result = {};
        headers.forEach((elem, index) => {
          result[elem] = array[index];
        });

        return result;
      };

      for (let i = 1; i < parsedDataLength; i++) {
        formedData.push(formObject(parsedData[i]));
      }

      return formedData;
    } catch {
      this.props.showAlert(true, "error", "This file couldn't be processed.");

      return [];
    }
  };

  onUpload = () => {
    const { fileUploaded, filterForm } = this.state;
    this.setState({
      uploadClicked: true,
      loadingXlsx: true
    });

    if (!fileUploaded) {
      this.props.showAlert(true, "error", "Upload file first.");

      return false;
    }

    this.parseXlsxFile().then((data) => {
      if (data) {
        const formedData = this.formParsedResultData(data);
        if (formedData) {
          const fileHeadersList = data[0].map((elem, index) => {
            return {
              value: elem.toString(),
              label: elem.toString() === "midId" ? `Payout MID - ${this.getMidNameById(filterForm.payoutMidId)}` : elem.toString()
            };
          });

          if (data[0].indexOf("midId") < 0) {
            fileHeadersList.push({
              label: `Payout MID - ${this.getMidNameById(filterForm.payoutMidId)}`,
              value: "midId"
            });
          }
          
          this.setState({
            parsedData: {
              headers: fileHeadersList,
              data: formedData
            },
            showThirdStep: true,
            loadingXlsx: false
          }, () => {
            const { fieldHeaders, parsedData } = this.state;

            const fileHeaders = parsedData.headers;
            const headers = fieldHeaders.data();

            Object.entries(headers).forEach(([key, value]) => {
              const appropriateHeader = fileHeaders.find(header => header.value === key);
              if (appropriateHeader) {
                headers[key] = appropriateHeader.value;
              }
            });

            this.setState({
              fieldHeaders: Object.assign(fieldHeaders, headers)
            });
          });
        }
      } else {
        this.setState({
          loadingXlsx: false
        });
      }
    }).catch((err) => {
      if (err && err.message) {
        this.props.showAlert(true, "error", err.message);
      }
      this.setState({
        loadingXlsx: false
      });
    });
  };

  parseXlsxFile = () => {
    return new Promise((resolve, reject) => {
      const { fileUploaded } = this.state;
      const reader = new FileReader();
      reader.onload = function (e) {
        var data = e.target.result;
        const readedData = XLSX.read(data, { type: 'binary' });
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];

        /* Convert array to json*/
        const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
        resolve(dataParse);
      };

      reader.onerror = (event) => {
        this.props.showAlert(true, "error", "This file couldn't be processed.");
        reader.abort();
      };

      reader.readAsBinaryString(fileUploaded);
    }).catch(
      () => {
        this.props.showAlert(true, "error", "This file can't be processed.");

        return false;
      }
    );
  };

  onFileChange = (e) => {
    const file = e.target.files.length ? e.target.files[0] : "";
    if (file) {
      const splittedName = file.name.split(".");
      const extension = splittedName[splittedName.length - 1];
      if (extension !== "xlsx" && extension !== "xls") {
        this.props.showAlert(true, "error", "Wrong file format.");
      } else {
        this.setState({
          fileUploaded: e.target.files.length ? e.target.files[0] : ""
        });
      }
    }
  };

  onHeaderChange = (event, fieldName) => {
    const { fieldHeaders, finishImportClicked } = this.state;
    fieldHeaders[fieldName] = event ? event.value : event;

    if (finishImportClicked) {
      fieldHeaders.isFormValid();
    }

    this.setState({
      fieldHeaders
    });
  };

  filterHeaders = (fieldValue) => {
    const { parsedData, fieldHeaders } = this.state;
    const headers = parsedData.headers;
    const keys = fieldHeaders.fieldRules.map(elem => elem.name);

    const filteredHeaders = headers.filter(elem => !keys.some(key => fieldHeaders[key] === elem.value));
    const concatHeader = headers.find(elem => elem.value && elem.value === fieldValue);

    return (fieldValue && concatHeader) ? filteredHeaders.concat([concatHeader]) : filteredHeaders;
  };

  onFinishImport = () => {
    const { additionalFields, fieldHeaders, filterForm, parsedData } = this.state;
    const isFormValid = fieldHeaders.isFormValid();
    this.setState({
      fieldHeaders,
      finishImportClicked: true
    });

    if (isFormValid) {
      const headersData = fieldHeaders.data();
      const keys = Object.keys(headersData);
      const data = parsedData.data.map(elem => {
        return keys.reduce((accumulator, currElem) => {
          if (additionalFields.find(e => e.fieldName === currElem)) {
            accumulator = {
              ...accumulator,
              data: {
                ...accumulator.data,
                [currElem]: (elem[headersData[currElem]] || "").toString()
              }
            };
          } else {
            accumulator[currElem] = (elem[headersData[currElem]] || "").toString();
          }
          return accumulator;
        }, {});
      });

      this.setState({
        loadingXlsx: true
      });

      crudActions.post(`v2/payout/import`, {
        merchantId: filterForm.merchantId,
        midId: filterForm.payoutMidId,
        payoutDTOS: data
      }).then(
        () => {
          this.props.showAlert(true, "success", "Payout batch is being processed.");
          this.setState({
            loadingXlsx: false,
            ...this.getInitialState()
          });
        }
      ).catch(
        (err) => {
          this.setState({
            loadingXlsx: false
          });
          if (err && err.message) {
            this.props.showAlert(true, "error", err.message);
          }          
        }
      );
    }
  };

  render() {
    const {
      companies,
      companiesClients,
      companiesProviders,
      filterForm,
      fileUploaded,
      fieldHeaders,
      fields,
      loadingXlsx,
      showSecondStep,
      showThirdStep
    } = this.state;

    return (
      <Row flexGrow={ 1 } className="module payouts" vertical='start'>
        <Column flexGrow={ 1 }>
          <PageHeader
            title="Import Payouts"
            img={ PayoutIcon }
          />
          <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='start'>
            <Column flexGrow={ 1 } vertical='start' className="panel-block">
              <Panel>
                <Panel.Heading>
                  <Panel.Title>
                    SELECT
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  <div className="panel-content" style={ { overflow: 'unset' } }>
                    <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='end'>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <label> White Label </label>
                        <Select
                          className={ filterForm.errors.has('companyId') ? 'error-field' : "" }
                          value={ filterForm.companyId }
                          required={ true }
                          clearable={ false }
                          disabled={ showSecondStep }
                          onChange={ (value) => this.onFilterValueChange(value, 'companyId') }
                          options={ companies }
                        />
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <label> Merchant </label>
                        <Select
                          className={ filterForm.errors.has('merchantId') ? 'error-field' : "" }
                          value={ filterForm.merchantId }
                          required={ true }
                          clearable={ false }
                          disabled={ showSecondStep || !filterForm.companyId }
                          onChange={ (value) => this.onFilterValueChange(value, 'merchantId') }
                          options={ filterForm.companyId ? companiesClients[filterForm.companyId] : [] }
                        />
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <label> Provider </label>
                        <Select
                          className={ filterForm.errors.has('providerId') ? 'error-field' : "" }
                          value={ filterForm.providerId }
                          required={ true }
                          clearable={ false }
                          disabled={ showSecondStep || !filterForm.companyId || !filterForm.merchantId }
                          onChange={ (value) => this.onFilterValueChange(value, 'providerId') }
                          options={ filterForm.companyId ? companiesProviders[filterForm.companyId] : [] }
                        />
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <label> Payout MID </label>
                        <Select
                          className={ filterForm.errors.has('payoutMidId') ? 'error-field' : "" }
                          value={ filterForm.payoutMidId }
                          required={ true }
                          clearable={ false }
                          disabled={ showSecondStep || !filterForm.providerId }
                          onChange={ (value) => this.onFilterValueChange(value, 'payoutMidId') }
                          options={ this.filterMids() }
                        />
                      </Column>
                    </Row>
                    <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='end'>
                      <Column flexGrow={ 1 } vertical='start' className="input-column empty-column">
                        <span/>
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' className="input-column empty-column">
                        <span/>
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' className="input-column empty-column">
                        <span/>
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' className="input-column">
                        <CustomButton
                          title="Submit"
                          type="submit"
                          disabled={ showSecondStep }
                          className={ showSecondStep && 'btn-secondary' }
                          onClick={ () => this.onSubmit() }
                        />
                      </Column>
                    </Row>
                  </div>
                </Panel.Body>
              </Panel>

              { showSecondStep && (
                <Panel>
                  <Panel.Heading>
                    <Panel.Title>
                      IMPORT PAYOUTS
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>
                    {loadingXlsx ? (
                      <div style={ { width: "100%", height: "400px", display: "flex", alignItems: "center", justifyContent: "center" } }>
                        <Spinner smallContainer={ true } />
                      </div>
                    ) : !showThirdStep ? (
                      <div className="panel-content" style={ { overflow: 'unset' } }>
                        <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='end'>
                          <Column flexGrow={ 1 } vertical='start' alignSelf="end" className="input-column">
                            <label> Upload file (.xlsx, .xls) </label>
                            <input
                              id="file-upload"
                              type="file"
                              accept=".xlsx, .xls"
                              onChange={ (e) => this.onFileChange(e) }
                            />
                            <label htmlFor="file-upload" className="file-upload">
                              { !fileUploaded ? "No files uploaded yet." : fileUploaded.name}
                              <span className="browse"> Browse... </span>
                            </label>
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf="end" className="input-column">
                            <CustomButton
                              title="Upload"
                              type="submit"
                              onClick={ () => this.onUpload() }
                            />
                          </Column>
                        </Row>
                      </div>
                    ) : (
                      <div className="panel-content" style={ { overflow: 'unset' } }>
                        <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='end' className="import-row">
                          <Column flexGrow={ 1 } vertical='start' alignSelf="end" className="import-column">
                            <h4> Your table headers </h4>
                          </Column>
                          <Column flexGrow={ 0 } vertical='start' alignSelf="end" className="import-column">
                            <span/>
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf="end" className="import-column">
                            <h4> Required Values </h4>
                          </Column>
                        </Row>
                        {fields.map(field => {
                          return (
                            <Row key={ field.fieldName } flexGrow={ 1 } horizontal='start' wrap={ true } vertical='end' className="import-row">
                              <Column flexGrow={ 1 } vertical='start' alignSelf="end" className="import-column">
                                <Select
                                  className={ fieldHeaders.errors.has(field.fieldName) ? 'error-field' : "" }
                                  value={ fieldHeaders[field.fieldName] || "" }
                                  required={ true }
                                  clearable={ false }
                                  disabled={ field.fieldName === "midId" }
                                  onChange={ (value) => this.onHeaderChange(value, field.fieldName) }
                                  options={ this.filterHeaders(fieldHeaders[field.fieldName]) }
                                />
                              </Column>
                              <Column flexGrow={ 0 } vertical='center' horizontal="center" alignSelf="end" className="arrow-column">
                                <img src={ Arrow } alt="arrow" style={ { width: 20, height: 12 } }/>
                              </Column>
                              <Column flexGrow={ 1 } vertical='start' alignSelf="end" className="import-column">
                                <input
                                  className="form-control"
                                  disabled
                                  value={ field.fieldLabel }
                                />
                              </Column>
                            </Row>
                          );
                        })}
                        <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='end' className="import-row">
                          <Column flexGrow={ 1 } vertical='start' alignSelf="end" className="input-column">
                            <span/>
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf="end" className="input-column">
                            <span/>
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf="end" className="input-column">
                            <span/>
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf="end" className="input-column">
                            <CustomButton
                              title="Finish import"
                              type="submit"
                              onClick={ () => this.onFinishImport() }
                            />
                          </Column>
                        </Row>
                      </div>
                    )}
                  </Panel.Body>
                </Panel>
              )}
            </Column>
          </Row>
        </Column>
      </Row>
    );
  }
};

function mapStateToProps(state) {
  return {
    alert: state.alert
  };
};

export default connect(mapStateToProps, actions)(ManualPayout);
